import { render, staticRenderFns } from "./Announcements.vue?vue&type=template&id=4bfae912&scoped=true&"
import script from "./Announcements.vue?vue&type=script&lang=js&"
export * from "./Announcements.vue?vue&type=script&lang=js&"
import style0 from "./Announcements.vue?vue&type=style&index=0&id=4bfae912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfae912",
  null
  
)

export default component.exports